import ApiClient from '../../../../utils/api/ApiClient'

const getMimsEula = async () => {
  const response = await ApiClient.get('/products/eula')
  return response.data
}

export default getMimsEula
